import { UserRequestSchema, IUserRequest } from "./helper-schemas";
import { ToInsertKeys, insertStripKeys } from "../helper-schemas";

export const APOSTUserRequestSchema = UserRequestSchema.keys(insertStripKeys);
export type IAPOSTUserRequest = ToInsertKeys<IUserRequest>;

export const RPOSTUserRequestSchema = UserRequestSchema;
export type IRPOSTUserRequest = IUserRequest;
